import React from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import logo from './img/JESMDU.png';

export default function NavbarMain() {
  const { pathname } = useLocation();
  const isApplicationActive = pathname.startsWith('/application');
  const isKanalActive = pathname.startsWith('/kanal');
  const isGalleryActive = pathname.startsWith('/gallery');

        <style>{`
          .modern-nav-link, .dropdown-item {
            text-transform: none !important;
          }
          ...existing code...
        `}</style>
  return (
    <div><div className="container-fluid p-0">
    <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-lg-5 modern-navbar shadow-sm rounded">
      {/*  <a href="index.html" className="navbar-brand ml-lg-3">
            <h3 className="m-0 text-uppercase text-primary"><img  className="position-absolute w-15 h-50 mr-5"  src="img/JESMDU.png" /><span style={{paddingLeft: "60px"}}>Madurai School Edu</span></h3>
        </a> */}

        <a href="https://mduschooled.in" className="navbar-brand ml-lg-3 d-flex align-items-center" style={{height: "50px"}}>
            <img className="nav-img-logo img-fluid" src={logo} style={{height: "44px", width: "auto", objectFit: "contain", marginRight: "12px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(44,62,80,0.10)"}} alt="Logo" />
            <span className="nav-brand-text" style={{fontSize: "1.35rem", fontWeight: 600, lineHeight: "50px", color: "#1a2740", letterSpacing: "1px"}}>Madurai School Edu</span>
        </a>
        <button type="button" className="navbar-toggler border-0" data-toggle="collapse" data-target="#navbarCollapse" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" style={{fontSize: '1.5rem'}}></span>
        </button>
        <div className="collapse navbar-collapse px-lg-3" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0 gap-2 gap-lg-3">
                <NavLink to="/" end className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Home</NavLink>
                <NavLink to="/schools" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Schools</NavLink>
                <NavLink to="/members" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Members</NavLink>
                <NavLink to="/reports" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Reports</NavLink>
              {/*  <NavLink to="/application" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Applicatiox`n</NavLink> */}
                <div className="nav-item dropdown">
                  <a href="#" className={`nav-link dropdown-toggle modern-nav-link${isApplicationActive ? ' active' : ''}`} data-toggle="dropdown" onClick={(event) => event.preventDefault()}>Application</a>
                    <div className="dropdown-menu m-0">
                        <NavLink to="/application" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Aided</NavLink>
                        <NavLink to="/application/cbse" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Self-Financed (CBSE)</NavLink>
                    </div>
                </div>
                <div className="nav-item dropdown">
                  <NavLink to="/kanal" className={`nav-link dropdown-toggle modern-nav-link${isKanalActive ? ' active' : ''}`} data-toggle="dropdown">Kanal</NavLink>
                    <div className="dropdown-menu m-0">
                        <NavLink to="/kanal" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Current Issue</NavLink>
                        <NavLink to="/kanal/archieves" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Archieves</NavLink>
                    </div>
                </div>
                <div className="nav-item dropdown">
                  <a href="#" className={`nav-link dropdown-toggle modern-nav-link${isGalleryActive ? ' active' : ''}`} data-toggle="dropdown" onClick={(event) => event.preventDefault()}>Gallery</a>
                    <div className="dropdown-menu m-0">
                        <NavLink to="/gallery/photo" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Photo</NavLink>
                        <NavLink to="/gallery/video" className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}>Video</NavLink>
                    </div>
                </div>
                
                {/*<NavLink to="/gallery" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Gallery</NavLink>*/}
                <NavLink to="/contact" className={({ isActive }) => "nav-item nav-link modern-nav-link" + (isActive ? " active" : "")}>Contact</NavLink>
        <style>{`
          .modern-navbar {
            background: #fff;
            border-radius: 16px;
            box-shadow: 0 2px 16px 0 rgba(44,62,80,0.10);
            border: 1px solid #e0e7ef;
          }
          .modern-nav-link {
            font-size: 1.08rem;
            font-weight: 500;
            color: #1a2740 !important;
            padding: 0.5rem 1.1rem;
            border-radius: 8px;
            transition: background 0.2s, color 0.2s;
            margin: 0 2px;
          }
          .modern-nav-link:hover, .modern-nav-link.active {
            background: #e0e7ef !important;
            color: #2c3e50 !important;
            text-decoration: none;
          }
          .navbar-brand .nav-brand-text {
            color: #1a2740 !important;
            font-weight: 600;
            letter-spacing: 1px;
          }
          .navbar-toggler {
            border-radius: 8px;
            background: #e0e7ef;
            transition: background 0.2s;
          }
          .navbar-toggler:focus {
            outline: none;
            box-shadow: 0 0 0 2px #c7d2fe;
          }
          .dropdown-menu {
            border-radius: 10px !important;
            box-shadow: 0 2px 12px 0 rgba(44,62,80,0.10) !important;
            border: 1px solid #e0e7ef !important;
            min-width: 180px;
          }
          .dropdown-item {
            font-size: 1rem;
            color: #1a2740 !important;
            border-radius: 6px;
            transition: background 0.2s, color 0.2s;
          }
          .dropdown-item:hover, .dropdown-item.active {
            background: #e0e7ef !important;
            color: #2c3e50 !important;
          }
          @media (max-width: 991.98px) {
            .modern-navbar {
              border-radius: 0;
              box-shadow: 0 2px 8px 0 rgba(44,62,80,0.07);
            }
            .modern-nav-link {
              font-size: 1rem;
              padding: 0.5rem 0.7rem;
            }
          }
        `}</style>
            </div>
            {/* Login button removed as requested */}
        </div>
    </nav>
</div>
{/*
    <div><div className="container-fluid p-0">
        
    <nav className="navbar navbar-expand-lg bg-white navbar-light ">
     
        <Col xs={2}>
       
        <a href="index.html" className="navbar-brand ml-lg-3 d-flex flex-row">
            <div className='nav-item-div'>
                    <img  className="nav-img-logo img-fluid "  src="img/JESMDU.png" />
            </div>
            <div className='nav-item-div nav-brand-text'>
                <span style={{paddingLeft: "15px"}}>Madurai School Edu</span>
            </div>            
        </a> 
        </Col>
     
       <Col xs={8}>
      
       
        <div className="collapse navbar-collapse px-lg-3 " id="navbarCollapse">
            <div className="navbar-nav ">
                <a href="index.html" className="nav-item nav-link active">Home</a>
                <a href="about.html" className="nav-item nav-link">Schools</a>
                <a href="course.html" className="nav-item nav-link">Members</a>
                <a href="about.html" className="nav-item nav-link">Programmes</a>
                <a href="course.html" className="nav-item nav-link">Application</a>
                <div className="nav-item dropdown">
                    <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown">Kanal</a>
                    <div className="dropdown-menu m-0">
                        <a href="detail.html" className="dropdown-item">Current Issue</a>
                        <a href="feature.html" className="dropdown-item">Archieves</a>
                    </div>
                </div>
                <a href="contact.html" className="nav-item nav-link">Contact</a>
            </div>
           
        </div> 
        </Col> 
<Col xs={1}>
             <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
            <span className="navbar-toggler-icon"></span>
        </button>
          </Col>
          <Col xs={1} style={{display:"inline-flex", justifyContent:"flex-end", paddingRight:"2%"}}>
          
           <a href="" className="btn rounded btn-primary  d-none d-lg-block" style={{width:"80px"}}>Login</a>
          </Col>
          
    </nav>
</div>
</div>
*/}
</div>
  )
}
